import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formElements, SaveButton, Title } from '../common';
import * as portalSetupActions from './portal-setup.actions';
import * as setupConstants from './portal-setup-constants';
import { toastr } from 'react-redux-toastr';
import './portal-setup.scss';

export class PortalSetup extends Component {

  getValue(section) {
    const { portalSetup } =this.props;
    const { value } = portalSetup;
    return value && value.get(section);
  }

  handleChange(section, value) {
    const { portalSetupActions } =this.props;
    const { updateValue, validateForm } = portalSetupActions;

    updateValue(["value", section], value);
    validateForm();
  }

  handleFormSubmit() {
    const { portalSetup, portalSetupActions } =this.props;
    const { validation } = portalSetup;
    const { createUser, showValidation } = portalSetupActions;
    if(validation.length === 0) {
      createUser()
        .then(val => {
          toastr.success('Success', 'Portal Account Setup');
        })
        .catch(err => {
          toastr.error(err.errorCode, err.errorMessage);
        });
    }
    else {
      showValidation();
    }
  }

  render() {
    const { portalSetup } =this.props;
    const { userCreationState, validation, showValidation } = portalSetup;
    const { isFetching } = userCreationState;

    return (
      <div>
        <Title title="Self-Service Portal Setup"/>
        <h1>Self-Service Portal Setup</h1>
        <div className="portal-setup-form">
          <div className='row'>
            <formElements.SimpleTextElement
              id={setupConstants.urlSection}
              label='Self-Service Portal URL'
              response={this.getValue(setupConstants.urlSection)}
              onChange={(value) => this.handleChange(setupConstants.urlSection, value)}
              isRequired={true}
              disabled={isFetching}
              errors={validation && validation.filter(val => val.sourceId === setupConstants.urlSection)}
              showErrors={showValidation}
              css={{
                label : "col-sm-4 label-override",
                displayWrapper : "col-sm-4"
              }}/>
            <span className="col-sm-4">.socialsolutionsportal.com</span>
          </div>
          <div className='row'>
            <formElements.SimpleTextElement
              id={setupConstants.assetIdSection}
              label='Salesforce Asset ID'
              response={this.getValue(setupConstants.assetIdSection)}
              onChange={(value) => this.handleChange(setupConstants.assetIdSection, value)}
              isRequired={true}
              disabled={isFetching}
              errors={validation && validation.filter(val => val.sourceId === setupConstants.assetIdSection)}
              showErrors={showValidation}
              css={{
                label : "col-sm-4 label-override",
                displayWrapper : "col-sm-4"
              }}/>
          </div>
          <div className='row'>
            <formElements.GuidElement
              id={setupConstants.enterpriseSection}
              label='Enterprise GUID'
              response={this.getValue(setupConstants.enterpriseSection)}
              onChange={(value) => this.handleChange(setupConstants.enterpriseSection, value)}
              isRequired={true}
              disabled={isFetching}
              errors={validation && validation.filter(val => val.sourceId === setupConstants.enterpriseSection)}
              showErrors={showValidation}
              css={{
                label : "col-sm-4 label-override",
                displayWrapper : "col-sm-4"
              }}/>
          </div>
          <div className='row'>
            <formElements.IntElement
              id={setupConstants.apiUserSection}
              label='Portal Login Id'
              response={this.getValue(setupConstants.apiUserSection)}
              onChange={(value) => this.handleChange(setupConstants.apiUserSection, value)}
              isRequired={true}
              disabled={isFetching}
              errors={validation && validation.filter(val => val.sourceId === setupConstants.apiUserSection)}
              showErrors={showValidation}
              css={{
                label : "col-sm-4 label-override",
                displayWrapper : "col-sm-4"
              }}/>
          </div>
          <div className="actions">
            <SaveButton
              text="Submit"
              savingText="Submitting..."
              saving={isFetching}
              onSave={e => this.handleFormSubmit(e)}/>
            <button className="btn btn-default">
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PortalSetup.propTypes = {
  portalSetup : PropTypes.any,
  portalSetupActions : PropTypes.any,
};

const mapStateToProps = ({ portalSetup }) => {
  return {
    portalSetup
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    portalSetupActions: bindActionCreators(portalSetupActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PortalSetup);



// WEBPACK FOOTER //
// src/portal-setup/portal-setup.js